import React from "react";
import type { BinanceTradeSyncInfo } from "../../utils/binanceTradeSync";
import BrokerHistoryPathChoice from "./BrokerHistoryPathChoice";

export interface BinanceHistoryPathChoiceProps {
  tradeSync: BinanceTradeSyncInfo;
  variant?: "card" | "plain";
  onChooseRecentOnly: () => void;
  onChooseNeedsCsv: () => void;
}

const BinanceHistoryPathChoice: React.FC<BinanceHistoryPathChoiceProps> = ({
  tradeSync,
  variant = "card",
  onChooseRecentOnly,
  onChooseNeedsCsv,
}) => (
  <BrokerHistoryPathChoice
    variant={variant}
    tradeSync={{
      syncLookbackDays: tradeSync.apiSyncLookbackDays,
      syncFromDate: tradeSync.apiSyncFromDate,
      syncToDate: tradeSync.apiSyncToDate,
    }}
    syncLabel="Binance API sync"
    recentPathLabel="Broker Sync"
    onChooseRecentOnly={onChooseRecentOnly}
    onChooseNeedsCsv={onChooseNeedsCsv}
  />
);

export default BinanceHistoryPathChoice;
